import { defineMessages } from "react-intl";

export const giftCardCreateExpirySelectMessages = defineMessages({
  expirySelectedLabel: {
    id: "rzhcpD",
    defaultMessage: "Set gift card expiry date",
    description: "set expiry date selected label",
  },
  expiryPeriodLabel: {
    id: "rl1t+o",
    defaultMessage: "Expires in",
    description: "expires in label",
  },
  expiryDateLabel: {
    id: "YBqLHs",
    defaultMessage: "Exact date",
    description: "expiry date label",
  },
  expiryOnLabel: {
    id: "fzl482",
    defaultMessage: "Will expire on:",
    description: "expires on label",
  },
});
